const caseList = [
    {
        Title: "全钢实验台案例",
        Img: [require('@/assets/img/project/qgsyt/qgsyt1.png'), require('@/assets/img/project/qgsyt/qgsyt2.png'), require('@/assets/img/project/qgsyt/qgsyt3.png'), require('@/assets/img/project/qgsyt/qgsyt4.png'), require('@/assets/img/project/qgsyt/qgsyt5.png'), require('@/assets/img/project/qgsyt/qgsyt6.png')],
        Content: "",
    },
    {
        Title: "气路案例",
        Img: [require('@/assets/img/project/qilu/qilu1.png'), require('@/assets/img/project/qilu/qilu2.png'), require('@/assets/img/project/qilu/qilu3.png'), require('@/assets/img/project/qilu/qilu4.png')],
        Content: "",
    },
    {
        Title: "钢木实验台案例",
        Img: [require('@/assets/img/project/gmsyt/gmsyt1.png'), require('@/assets/img/project/gmsyt/gmsyt2.png'), require('@/assets/img/project/gmsyt/gmsyt3.png'), require('@/assets/img/project/gmsyt/gmsyt4.png'), require('@/assets/img/project/gmsyt/gmsyt5.png'), require('@/assets/img/project/gmsyt/gmsyt6.png')],
        Content: "",
    },
    {
        Title: "通风设备案例",
        Img: [require('@/assets/img/project/tfsb/tfsb2.png'), require('@/assets/img/project/tfsb/tfsb3.png'), require('@/assets/img/project/tfsb/tfsb4.png'), require('@/assets/img/project/tfsb/tfsb5.png'),],
        Content: "",
    },
    {
        Title: "尾气处理案例",
        Img: [require('@/assets/img/project/wqcl/wqcl1.png'), require('@/assets/img/project/wqcl/wqcl2.png'), require('@/assets/img/project/wqcl/wqcl3.png'), require('@/assets/img/project/wqcl/wqcl4.png'),],
        Content: "",
    },
    {
        Title: "净化实验室案例",
        Img: [require('@/assets/img/project/jhsys/jhsys1.png'), require('@/assets/img/project/jhsys/jhsys2.png'), require('@/assets/img/project/jhsys/jhsys3.png'), require('@/assets/img/project/jhsys/jhsys4.png'), require('@/assets/img/project/jhsys/jhsys5.png')],
        Content: "",
    },
    {
        Title: "细胞实验室案例",
        Img: [require('@/assets/img/project/xbsys/xbsys1.png'), require('@/assets/img/project/xbsys/xbsys2.png'), require('@/assets/img/project/xbsys/xbsys3.png'), require('@/assets/img/project/xbsys/xbsys4.png'), require('@/assets/img/project/xbsys/xbsys5.png')],
        Content: "",
    },
    {
        Title: "医院案例",
        Img: [require('@/assets/img/project/yy/yy1.png'), require('@/assets/img/project/yy/yy2.png'), require('@/assets/img/project/yy/yy3.png'), require('@/assets/img/project/yy/yy4.png'), require('@/assets/img/project/yy/yy5.png')],
        Content: "",
    },
    {
        Title: "PCR实验室案例",
        Img: [require('@/assets/img/project/pcr/pcr1.png'), require('@/assets/img/project/pcr/pcr2.png'), require('@/assets/img/project/pcr/pcr3.png'), require('@/assets/img/project/pcr/pcr4.png')],
        Content: "",
    },

]
const productList = [
    {
        label: "实验台",
        name: "实验台",
        list: [
            {
                title: 'PP实验台',
                descrip: '',
                img: require('@/assets/img/case/PP实验台.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '钢木实验台',
                descrip: '',
                img: require('@/assets/img/case/钢木实验台.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '全钢实验台',
                descrip: '',
                img: require('@/assets/img/case/全钢实验台.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '中央实验台',
                descrip: '',
                img: require('@/assets/img/case/中央实验台.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },
    {
        label: "实验室设备",
        name: "实验室设备",
        list: [
            {
                title: '天平台',
                descrip: '',
                img: require('@/assets/img/case/天平台.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '气瓶柜',
                descrip: '',
                img: require('@/assets/img/case/气瓶柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '器皿柜',
                descrip: '',
                img: require('@/assets/img/case/器皿柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '试剂柜',
                descrip: '',
                img: require('@/assets/img/case/试剂柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },

            {
                title: '洗涤台',
                descrip: '',
                img: require('@/assets/img/case/洗涤台.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '药品柜',
                descrip: '',
                img: require('@/assets/img/case/药品柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },
    {
        label: "实验室通风系统",
        name: "实验室通风系统",
        list: [
            {
                title: '实验室通风系统1',
                descrip: '',
                img: require('@/assets/img/case/实验室通风系统.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室通风系统2',
                descrip: '',
                img: require('@/assets/img/case/实验室通风系统2.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室通风系统3',
                descrip: '',
                img: require('@/assets/img/case/实验室通风系统3.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室通风系统4',
                descrip: '',
                img: require('@/assets/img/case/实验室通风系统4.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },

    {
        label: "通风柜",
        name: "通风柜",
        list: [
            {
                title: 'PP通风柜',
                descrip: '',
                img: require('@/assets/img/case/PP通风柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '不锈钢通风柜',
                descrip: '',
                img: require('@/assets/img/case/不锈钢通风柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '落地通风柜',
                descrip: '',
                img: require('@/assets/img/case/落地通风柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '全钢通风柜',
                descrip: '',
                img: require('@/assets/img/case/全钢通风柜.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },
    {
        label: "反辐射工程",
        name: "反辐射工程",
        list: [
            {
                title: '实验室铅门',
                descrip: '',
                img: require('@/assets/img/case/实验室铅门.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室铅板',
                descrip: '',
                img: require('@/assets/img/case/实验室铅板.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '硫酸钡砂',
                descrip: '',
                img: require('@/assets/img/case/硫酸钡砂.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '硫酸钡板',
                descrip: '',
                img: require('@/assets/img/case/硫酸钡板.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },
    {
        label: "实验室净化",
        name: "实验室净化",
        list: [
            {
                title: '实验室净化1',
                descrip: '',
                img: require('@/assets/img/case/实验室净化.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室净化2',
                descrip: '',
                img: require('@/assets/img/case/实验室净化2.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室净化3',
                descrip: '',
                img: require('@/assets/img/case/实验室净化3.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '实验室净化4',
                descrip: '',
                img: require('@/assets/img/case/实验室净化4.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },
    {
        label: "实验室气体管路",
        name: "实验室气体管路",
        list: [
            {
                title: '气体管路1',
                descrip: '',
                img: require('@/assets/img/case/气体管路.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '气体管路2',
                descrip: '',
                img: require('@/assets/img/case/气体管路1.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '气体管路3',
                descrip: '',
                img: require('@/assets/img/case/气体管路2.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
            {
                title: '气体管路4',
                descrip: '',
                img: require('@/assets/img/case/气体管路3.jpg'),
                number: Math.floor(1000 + Math.random() * 3000)
            },
        ]
    },
]
export { caseList, productList }
